import gql from "graphql-tag"

export const BLOG_LIST = gql`
  query blogs($where: BlogWhereInput) {
    blogCount(where: $where) {
      count
    }
    blogs(where: $where) {
      id
      title
      createdAt
      description
      thumbnailUrl
      tag {
        name
      }
      user {
        id
        firstName
        avatarUrl
        lastName
      }
      like_blog {
        id
        user {
          id
        }
      }
    }
  }
`

export const TAGS = gql`
  query getTags {
    getTags {
      id
      name
    }
  }
`

export const IS_LIKE_BLOG = gql`
  mutation isLikeBlog($where: BlogWhereInput) {
    isLikeBlog(where: $where) {
      status
      message
    }
  }
`

export const fetchBlogList = async (client, skipNo, authState, tags = "", isPublished, sortBy) => {
  try {
    return await client.query({
      query: BLOG_LIST,
      variables: {
        where: {
          skip: skipNo,
          take: 6,
          userId: authState && authState.state && authState.state.user && authState.state.user.id,
          tag: tags,
          isPublished,
          sortBy
        }
      }
    })
  } catch (error) {
    console.log("Error", error)
  }
}

export const isLikeBlog = async (client, id, likeType) => {
  try {
    return await client.mutate({
      mutation: IS_LIKE_BLOG,
      variables: {
        where: {
          id,
          likeType
        }
      }
    })
  } catch (error) {
    console.log("Error", error)
  }
}

export const fetchTags = async client => {
  try {
    return await client.query({
      query: TAGS
    })
  } catch (error) {
    console.log("Error", error)
  }
}
